module.exports = __webpack_public_path__ + "img/flipPhoneIcon.0a688d65.png";